import React from 'react';

const BeBacks = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg height="20" width="20" fill="none" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.24609 9.37821L2.49661 8.12769L3.74714 9.37821"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M18.7549 10.6255L17.5044 11.876L16.2539 10.6255"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3.89844 5.65659C5.96225 2.72887 9.80987 1.67178 13.0798 3.13411C16.3497 4.59644 18.127 8.16899 17.3207 11.6591"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M16.1036 14.3436C14.0398 17.2713 10.1922 18.3284 6.92225 16.866C3.65232 15.4037 1.8751 11.8312 2.68136 8.34106"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.3374 13.3349C13.2405 13.091 13.0901 12.8719 12.8972 12.6938V12.6938C12.5723 12.3918 12.1453 12.2239 11.7017 12.2236H8.30448C7.86069 12.2239 7.43338 12.3919 7.10815 12.6938V12.6938C6.91577 12.8723 6.76543 13.0913 6.66797 13.3349"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle cx="10.0008" cy="8.54106" r="1.87578" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
    </svg>
  );
};

export default BeBacks;
